import { render } from "./Slide12.vue?vue&type=template&id=1dd06660&scoped=true"
import script from "./Slide12.vue?vue&type=script&lang=js"
export * from "./Slide12.vue?vue&type=script&lang=js"

import "./Slide12.vue?vue&type=style&index=0&id=1dd06660&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dd06660"]])

export default __exports__